import { Injectable } from '@angular/core';
import { FilterService } from '../services/filter.service';
import { InvoiceQuery } from '../../../models/invoice-query';
import { FilterAssistQuery } from '../../../interfaces/filter-assist-query';
import { Observable, of } from 'rxjs';
import { FilterAssist } from '../../../models/filter-assist';
import { FilterCategoryEnum } from '../../../enum/filter-category.enum';

@Injectable({  providedIn: 'root' })
export class InvoiceFilterService extends FilterService<InvoiceQuery> implements FilterAssistQuery<InvoiceQuery> {

    private INVOICE_FILTER = 'INVOICE_FILTER';

    constructor() {
        super();
        this.registerFilters(this);
    }

    protected describe(terms: string): string {
        return $localize`Filter for "${terms}"`;
    }

    active(query: InvoiceQuery): Observable<FilterAssist[]> {
        if (query.reference) {
            return of([ {
                id: this.INVOICE_FILTER,
                description: this.describe(query.reference),
                score: 50,
                parameter: query.reference,
                category: FilterCategoryEnum.ANY
            } ]);
        }
        return of([]);
    }

    apply(id: string, parameter: any, query: InvoiceQuery): void {
        switch (id) {
            case this.INVOICE_FILTER:
                query.reference = parameter;
                break;
        }
    }

    ids(): string[] {
        return [ this.INVOICE_FILTER ];
    }

    match(terms: string): Observable<FilterAssist[]> {
        if (terms.length < 2) {
            return of([]);
        }
        return of([ {
            id: this.INVOICE_FILTER,
            parameter: terms,
            score: 50,
            description: this.describe(terms),
            category: FilterCategoryEnum.ANY
        } ]);
    }

    unapply(id: string, query: InvoiceQuery): void {
        switch (id) {
            case this.INVOICE_FILTER:
                query.reference = null;
                break;
        }
    }
}
